import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyShowCSM = lazyWithRetry(() => import('./ShowCSM'));
export const LazyShowCSMAdmin = lazyWithRetry(() => import('./ShowCSMAdmin'));
